import type { NavigationGuardNext } from "vue-router";
import { getOnBoardRoute } from "@/router/onBoardingRoute";

export default async function requireOnBoarding({
  next,
  companyStore,
}: {
  next: NavigationGuardNext;
  companyStore: any;
}) {
  if (companyStore.companyOnboardingStatus === "") {
    return next();
  }

  if (companyStore.companyOnboardingStatus !== "COMPLETE") {
    let routeName = "welcome";

    if (companyStore.companyOnboardingStatus !== "") {
      routeName = getOnBoardRoute(companyStore.companyOnboardingStatus);
    }

    return next({
      name: routeName,
    });
  }

  return next();
}
